/* eslint-disable */

import React, { useEffect, useState } from "react";

import {
  Box,
  Card,
  Text,
  SimpleGrid,
  Spinner,
  Flex,
  Avatar,
  Badge,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  useColorModeValue,
} from "@chakra-ui/react";

import axiosClient from "../../../api/axiosClient";

export default function Leaderboard() {
  const [loading, setLoading] = useState(true);
  const [leaders, setLeaders] = useState([]);

  const cardBg = useColorModeValue("white", "navy.700");

  useEffect(() => {
    fetchLeaderboard();
  }, []);

  const fetchLeaderboard = async () => {
    try {
      const res = await axiosClient.get("/ticket-transfer/leaderboard");

      setLeaders(res.data.data || []);
    } catch (error) {
      console.error("Gagal ambil leaderboard", error);
    } finally {
      setLoading(false);
    }
  };

  const getBadgeColor = (rank) => {
    switch (rank) {
      case "Diamond":
        return "cyan";

      case "Platinum":
        return "purple";

      case "Gold":
        return "yellow";

      case "Silver":
        return "gray";

      default:
        return "orange";
    }
  };

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Text
        fontSize="2xl"
        fontWeight="bold"
        mb={6}
      >
        🏆 Leaderboard Teknisi ResolveIT
      </Text>

      {loading ? (
        <Flex justify="center">
          <Spinner size="xl" />
        </Flex>
      ) : (
        <>
          {/* TOP 3 */}

          <SimpleGrid
            columns={{ base: 1, md: 3 }}
            spacing="20px"
            mb="30px"
          >
            {leaders.slice(0, 3).map((user, index) => (
              <Card
                key={user.id}
                bg={cardBg}
                p="20px"
              >
                <Flex
                  direction="column"
                  align="center"
                >
                  <Text fontSize="4xl">
                    {index === 0 && "🥇"}
                    {index === 1 && "🥈"}
                    {index === 2 && "🥉"}
                  </Text>

                  <Avatar
                    mt={3}
                    name={user.name}
                    size="lg"
                  />

                  <Text
                    mt={3}
                    fontWeight="bold"
                    fontSize="lg"
                  >
                    {user.name}
                  </Text>

                  <Badge
                    mt={2}
                    colorScheme={getBadgeColor(user.rank)}
                  >
                    {user.rank}
                  </Badge>

                  <Text
                    mt={4}
                    fontSize="3xl"
                    fontWeight="bold"
                    color="blue.400"
                  >
                    {user.total_points}
                  </Text>

                  <Text color="gray.500">
                    Points
                  </Text>
                </Flex>
              </Card>
            ))}
          </SimpleGrid>

          {/* TABLE */}

          <Card p="20px">
            <Text
              fontWeight="bold"
              mb={4}
            >
              Ranking Teknisi
            </Text>

            <Table variant="simple">
              <Thead>
                <Tr>
                  <Th>Posisi</Th>
                  <Th>Nama</Th>
                  <Th>Rank</Th>
                  <Th isNumeric>Point</Th>
                </Tr>
              </Thead>

              <Tbody>
                {leaders.map((user, index) => (
                  <Tr key={user.id}>
                    <Td fontWeight="bold">
                      #{index + 1}
                    </Td>

                    <Td>{user.name}</Td>

                    <Td>
                      <Badge
                        colorScheme={getBadgeColor(
                          user.rank
                        )}
                      >
                        {user.rank}
                      </Badge>
                    </Td>

                    <Td isNumeric>
                      {user.total_points}
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Card>
        </>
      )}
    </Box>
  );
}